import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import { ClientsPage, ProjectsPage, MaterialsPage, ContractsPage } from "@/pages/Master";
import RatesPage from "@/pages/Rates";
import { PurchaseOrdersPage, DeliveryNotesPage, ReturnNotesPage } from "@/pages/Documents";
import GenerateTagihan from "@/pages/GenerateTagihan";
import Proforma from "@/pages/Proforma";
import Invoices from "@/pages/Invoices";
import Payments from "@/pages/Payments";
import Receivables from "@/pages/Receivables";
import Outstanding from "@/pages/Outstanding";
import Reconciliation from "@/pages/Reconciliation";
import Closing from "@/pages/Closing";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import Users from "@/pages/Users";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="h-10 w-10 border-2 border-[#9333EA] border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/clients" element={<Protected><ClientsPage /></Protected>} />
      <Route path="/projects" element={<Protected><ProjectsPage /></Protected>} />
      <Route path="/materials" element={<Protected><MaterialsPage /></Protected>} />
      <Route path="/contracts" element={<Protected><ContractsPage /></Protected>} />
      <Route path="/rates" element={<Protected><RatesPage /></Protected>} />
      <Route path="/purchase-orders" element={<Protected><PurchaseOrdersPage /></Protected>} />
      <Route path="/delivery-notes" element={<Protected><DeliveryNotesPage /></Protected>} />
      <Route path="/return-notes" element={<Protected><ReturnNotesPage /></Protected>} />
      <Route path="/generate" element={<Protected><GenerateTagihan /></Protected>} />
      <Route path="/proformas" element={<Protected><Proforma /></Protected>} />
      <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
      <Route path="/payments" element={<Protected><Payments /></Protected>} />
      <Route path="/receivables" element={<Protected><Receivables /></Protected>} />
      <Route path="/outstanding" element={<Protected><Outstanding /></Protected>} />
      <Route path="/reconciliation" element={<Protected><Reconciliation /></Protected>} />
      <Route path="/closing" element={<Protected><Closing /></Protected>} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
      <Route path="/users" element={<Protected><Users /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
